import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useRef, useState } from "react";
import { FadeIn, FadeOut } from "./ModalFade";
import { ParallaxBackground } from "./ParallaxBackground";
import "./Loading.css";
export const LoadingView = (props) => {
    const [fadedOut, setFadedOut] = useState(false);
    const [loadingMessage, setLoadingMessage] = useState("Loading");
    const fadingOut = useRef(false);
    const timing = useRef(false);
    let content;
    let message;
    useEffect(() => {
        if (timing.current)
            return;
        timing.current = true;
        setTimeout(() => {
            timing.current = false;
            switch (loadingMessage) {
                case "Loading":
                    setLoadingMessage("Loading.");
                    break;
                case "Loading.":
                    setLoadingMessage("Loading..");
                    break;
                case "Loading..":
                    setLoadingMessage("Loading...");
                    break;
                case "Loading...":
                    setLoadingMessage("Loading");
                    break;
            }
        }, 650);
    }, [loadingMessage]);
    if (!props.LoadingDone && fadedOut && fadingOut) {
        setFadedOut(false);
        fadingOut.current = false;
    }
    if ((props.StreamerStatus === 'streaming') &&
        props.LoadingDone) {
        if (!fadingOut.current) {
            // start fadeOut
            fadingOut.current = true;
            //const root = document.getElementById("root")?.setAttribute('style', 'width: 0%; height: 0%');
        }
    }
    message = loadingMessage;
    content = (_jsxs("div", Object.assign({ id: "loadingContainer" }, { children: [_jsx(ParallaxBackground, {}), _jsxs("div", Object.assign({ id: "textHolder" }, { children: [_jsx("h2", Object.assign({ id: "mainLoadingText", className: "loadingText fadeInText" }, { children: message })), _jsx("h2", Object.assign({ id: "extraLoadingText", className: "loadingText" }, { children: "For a premium experience, load times vary from 1-2 minutes" }))] }))] })));
    return (_jsxs(_Fragment, { children: [_jsx(FadeIn, {}), props.LoadingDone && _jsx(FadeOut, {}), _jsx("div", Object.assign({ id: "loadingViewContent" }, { children: content }))] }));
};
